import axios from 'axios';

import RsaHelper from '@/global-config/request/rsa/rsa-aes-helper'
function checkAuthTokenExclusion(arr, url) {
    return (arr.indexOf(url) != -1);
}

/*exclusion array, add those url to this array for which you dont want to set token in header*/
var exclusion = ['verify-email'];

var useSession = true

const MAX_REQUESTS_COUNT = 1
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0


const defaultOptions = {

    // baseURL: "/test.php", // for localhost new
    // baseURL: "/", // for localhost new
    // baseURL: "/api", // for built new, proxy in same folder


    // baseURL: "https://keymerchant.vaultspay.com/", // for localhost new
    baseURL: process.env.VUE_APP_API_BASE_URL, // for localhost new
    // baseURL: "/api", // for built new, proxy in same folder


    // baseURL: "https://merchant.vaultspay.com/api/", // for direct proxy url
    headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': "multipart/form-data",
        // 'Content-Type': "multipart/form-data",
        
    },
     withCredentials: true,
     crossDomain: true
};

// Create instance
var instance = axios.create(defaultOptions);

// instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// Set the AUTH token for any request
instance.interceptors.request.use(function (config) {

    return new Promise((resolve, reject) => {
        setTimeout(()=>{

        },500)
        let interval = setInterval(() => {
            if (PENDING_REQUESTS < MAX_REQUESTS_COUNT ) {
                PENDING_REQUESTS++
                clearInterval(interval)
                /*the token will be added to header for those url which are not found in the exclusion array*/
                if (!checkAuthTokenExclusion(exclusion, config.url)) {
                    if(!useSession){
                        const token = localStorage.getItem('vault-pay-access-token');
                        config.headers.accessToken = token ? token : '';
                    }

                }

                var attachment = null
                if(config.data && config.data.attachment){
                    attachment = config.data.attachment
                    delete config.data.attachment
                }

                let uri = config.data.uri

                // **** TO ACTIVE ENCRYPTION TOGGLE FROM ENVIRONMENT VARIABLE ****
                if(process.env.VUE_APP_ACTIVATE_ENC == 'true' || process.env.VUE_APP_ACTIVATE_ENC == true){
                    let encryptData =  RsaHelper.encryptRequest(config.data)

                    config.data = {
                        client : encryptData.rsaEncryptedKey,
                        backend : encryptData.aesEncryptedData,
                    }

                    if(attachment){
                        attachment.append('client', encryptData.rsaEncryptedKey)
                        attachment.append('backend', encryptData.aesEncryptedData)
                        let tempUri = window.btoa(uri)
                        // **** TO ACTIVE DUPLICATE REQUEST PREVENTION TOGGLE FROM ENVIRONMENT VARIABLE ****
                        if(process.env.VUE_APP_ACTIVATE_DUPLICATE_REQUEST_PREVENTION == 'true' || process.env.VUE_APP_ACTIVATE_DUPLICATE_REQUEST_PREVENTION == true){
                            tempUri = RsaHelper.encryptUriWithRSA(uri+':'+RsaHelper.generateLongObfuscatedNumber())
                        }
                        attachment.append('uri',  tempUri)
                        config.data = attachment

                    }
                }else{
                    if(attachment){
                        // let tempUri = window.btoa(uri)
                        // attachment.append('uri',  tempUri)
                        attachment.append('uri',  uri)
                        config.data = attachment
                    }
                }

                // encode to base 64
                config.data.uri = window.btoa(uri)

                // **** TO ACTIVE DUPLICATE REQUEST PREVENTION TOGGLE FROM ENVIRONMENT VARIABLE ****
                if(process.env.VUE_APP_ACTIVATE_DUPLICATE_REQUEST_PREVENTION == 'true' || process.env.VUE_APP_ACTIVATE_DUPLICATE_REQUEST_PREVENTION == true){
                    config.data.uri = RsaHelper.encryptUriWithRSA(uri+':'+RsaHelper.generateLongObfuscatedNumber())
                }

                resolve(config)
            }
        }, INTERVAL_MS)
    })

});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Do something with response data
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    if(!useSession){
        if (typeof (response.data.accessToken) != 'undefined') {
            localStorage.setItem('vault-pay-access-token', response.data.accessToken);
        }
    }
    return Promise.resolve(response)
    // return response;
}, function (error) {
    // Do something with response error
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
    return Promise.reject(error)
});

export default instance;
